<template>
  <div class="skb-nav-bar" :class="theme">
    <span class="site-name"><span class="brand-name">IBM</span><span class="product-name">SkillsBuild</span></span>
    <nav>
      <span class="menu-item">TechTypeQuiz.com</span>
    </nav>
  </div>
</template>

<script>
export default {
  name: 'SKBNavBar',
  props: {
    theme: {
      type: String,
      default: 'blue'
    }
  }
}
</script>

<style lang="scss" scoped>
.skb-nav-bar {
  position: sticky;
  z-index: 10;
  top: 0;
  background-color: $blue-100;
  color: $grey-10;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.16px;
  display: flex;
  align-items: center;
  box-shadow: 0 -1px 0 0 #fff inset;
  transition: all 2s ease-out;

  &.dark {
    background-color: $grey-100;
    box-shadow: 0 0 0 0 $grey-100 inset;
  }
}

.site-name {
  padding: 15px 32px 15px 16px;
  display: flex;
  gap: 3px;
}

.product-name {
  font-weight: 700;
}

nav {
  position: relative;
  color: $grey-30;
  padding-left: 16px;

  &::before {
    position: absolute;
    top: 50%;
    left: 0;
    display: block;
    width: 1px;
    height: 24px;
    transform: translateY(-50%);
    background-color: $grey-30;
    content: '';
  }

  .menu-item {
    padding: 15px 16px 15px 16px;
  }
}

.separator {
  height: 24px;
  width: 1px;
  background-color: $grey-30;
}
</style>
